import styled from 'styled-components';

export const CreateNewAccount = styled.div`
  text-align: center;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.color.neutral1};
  border: 1px solid #e0e0e0;
  borderradius: 5px;
  cursor: pointer;
  display: flex;
  height: 46px;
  background: #ffffff;
  &.active {
    box-shadow: inset 0 0 0 100pt rgba(109, 15, 167, 0.08);
    background-clip: padding-box;
  }
`;
